<template>
  <transition name="modal" appear>
    <div class="popWrap nowOpen orderBottom" id="optionPop" style="display: block;">
      <div class="popup">
        <div class="popContain">
          <div class="popCont hasOrderBtn">
            <div class="popBody">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section class="mb15">
                  <div class="titArea ac">
                    <h1 class="titH1 medium">상품 옵션 변경</h1>
                  </div>

                  <ul class="prdSlt">
                    <li v-if="rentalPeriodList.length > 1 && popFlag == 'rental'">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalDay = !rentalDay">
                          <span class="inner">
                            <span class="item">렌탈기간</span>
                            <span class="val placeholder" id="rentalDayText">{{ dayText }}</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalDay">
                        <ul class="iptGroup">
                          <li v-for="(rentalPeriod, rentalPeriodIndex) in productInfo.productOptions.rentalPeriod" :key="rentalPeriodIndex">
                            <input
                              type="radio"
                              class="ipt"
                              name="rentalPeriod"
                              :id="'rentalPeriod' + rentalPeriodIndex"
                              :value="rentalPeriod.optionName"
                              v-model="day"
                              @click="selectOptionItem(rentalPeriod.optionCode, 'rentalPeriod')"
                            />
                            <label :for="'rentalPeriod' + rentalPeriodIndex"><span v-text="rentalPeriod.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="colorList.length > 1">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalColor = !rentalColor">
                          <span class="inner">
                            <span class="item">색상</span>
                            <span class="val placeholder" id="rentalColorText" v-text="colorText"></span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalColor">
                        <ul class="iptGroup">
                          <li v-for="(productColor, colorIndex) in productInfo.productColors" :key="colorIndex">
                            <input
                              type="radio"
                              class="ipt"
                              name="productColor"
                              :id="'productColor' + colorIndex"
                              :value="productColor.colorCodeNm"
                              v-model="color"
                              @click="selectOptionItem(productColor.colorCode, 'color')"
                            />
                            <label :for="'productColor' + colorIndex"><span v-text="productColor.colorCodeNm"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="option1List.length > 0">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalOption1 = !rentalOption1">
                          <span class="inner">
                            <span class="item">옵션1</span>
                            <span class="val placeholder" id="rentalOptionText1" v-text="optionText1">선택해주세요</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalOption1">
                        <ul class="iptGroup">
                          <li v-for="(option1Value, option1Index) in productInfo.productOptions.productOption1" :key="option1Index">
                            <input
                              type="radio"
                              class="ipt"
                              name="option1"
                              :id="'option1' + option1Index"
                              :value="option1Value.optionName"
                              v-model="option1"
                              @click="selectOptionItem(option1Value.optionCode, 'optionCode1')"
                            />
                            <label :for="'option1' + option1Index"><span v-text="option1Value.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="option2List.length > 0">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalOption2 = !rentalOption2">
                          <span class="inner">
                            <span class="item">옵션2</span>
                            <span class="val placeholder" id="rentalOptionText2" v-text="optionText2">선택해주세요</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalOption2">
                        <ul class="iptGroup">
                          <li v-for="(option2Value, option2Index) in productInfo.productOptions.productOption2" :key="option2Index">
                            <input
                              type="radio"
                              class="ipt"
                              name="option2"
                              :id="'option2' + option2Index"
                              :value="option2Value.optionName"
                              v-model="option2"
                              @click="selectOptionItem(option2Value.optionCode, 'optionCode2')"
                            />
                            <label :for="'option2' + option2Index"><span v-text="option2Value.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="option3List.length > 0">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalOption3 = !rentalOption3">
                          <span class="inner">
                            <span class="item">옵션3</span>
                            <span class="val placeholder" id="rentalOptionText3" v-text="optionText3">선택해주세요</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalOption3">
                        <ul class="iptGroup">
                          <li v-for="(option3Value, option3Index) in productInfo.productOptions.productOption3" :key="option3Index">
                            <input
                              type="radio"
                              class="ipt"
                              name="option3"
                              :id="'option3' + option3Index"
                              :value="option3Value.optionName"
                              v-model="option3"
                              @click="selectOptionItem(option3Value.optionCode, 'optionCode3')"
                            />
                            <label :for="'option3' + option3Index"><span v-text="option3Value.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="instTypeList.length > 0">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalInstType = !rentalInstType">
                          <span class="inner">
                            <span class="item">유형</span>
                            <span class="val placeholder" id="instTypeText" v-text="instTypeText">선택해주세요</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalInstType">
                        <ul class="iptGroup">
                          <li v-for="(instTypeValue, instTypeIndex) in instTypeList" :key="instTypeIndex">
                            <input
                              type="radio"
                              class="ipt"
                              name="instType"
                              :id="'instType' + instTypeIndex"
                              :value="instTypeValue.optionName"
                              v-model="instType"
                              @click="selectOptionItem(instTypeValue.optionCode, 'instType')"
                            />
                            <label :for="'instType' + instTypeIndex"><span v-text="instTypeValue.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li v-if="checkTypeList.length > 0">
                      <div class="accoHead">
                        <div class="accoBtn" @click="rentalCheckType = !rentalCheckType">
                          <span class="inner">
                            <span class="item">점검</span>
                            <span class="val placeholder" id="checkTypeText" v-text="checkTypeText">선택해주세요</span>
                          </span>
                        </div>
                      </div>
                      <div class="accoBody" v-show="rentalCheckType">
                        <ul class="iptGroup">
                          <li v-for="(checkTypeValue, checkTypeIndex) in checkTypeList" :key="checkTypeIndex">
                            <input
                              type="radio"
                              class="ipt"
                              name="checkType"
                              :id="'checkType' + checkTypeIndex"
                              :value="checkTypeValue.optionName"
                              v-model="checkType"
                              @click="selectOptionItem(checkTypeValue.optionCode, 'checkType')"
                            />
                            <label :for="'checkType' + checkTypeIndex"><span v-text="checkTypeValue.optionName"></span></label>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>
            <div class="orderBottom">
              <div class="bottomArea">
                <div class="prdPrice">
                  <div class="row">
                    <span class="info" v-text="btnText"></span>
                    <div class="val">
                      <span class="price pointC1">
                        월
                        <em class="money" v-text="getConvertPrice(amount)"></em>
                        원
                      </span>
                    </div>
                  </div>
                </div>
                <p class="txtXS pointC6 mt5 ar" v-if="popFlag == 'rental'">
                  제휴카드 사용시
                  <span class="pointC4">
                    최대 월
                    <i>17,000</i>
                    <!--<i v-text="getConvertPrice(productInfo.productDetail.cardDcAmount)"></i>-->
                    원
                  </span>
                  청구 할인
                </p>
              </div>

              <div class="btnArea two half">
                <button type="button" class="btn_g" @click="$emit('close')">취소</button>
                <button type="button" class="btn_p" @click="selectOption">확인</button>
              </div>
            </div>

            <!-- <button type="button" class="btnIco_close" onclick="lp.close();"><span>팝업 닫기</span></button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
  </transition>
</template>
<script>
import { convertPrice } from '@/common/common.filter';
import * as customjs from '@/../static/js/m.front.js';
import { isEmpty } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import { ALLOPTION_SELECT } from '@/store/message.type.js';
import $ from 'jquery';

export default {
  name: 'OptionPop',
  props: ['propsObj', 'flag'],
  components: {
    MessagePop,
  },
  data() {
    return {
      rentalDay: false,
      day: '',
      dayText: '선택해주세요',
      rentalColor: false,
      rentalOption1: false,
      rentalOption2: false,
      rentalOption3: false,
      color: '',
      colorText: '선택해주세요',
      option1: '',
      option2: '',
      option3: '',
      optionText1: '선택해주세요',
      optionText2: '선택해주세요',
      optionText3: '선택해주세요',
      rentalInstType: null,
      rentalCheckType: null,
      instTypeText: '선택해주세요',
      checkTypeText: '선택해주세요',
      instType: '',
      checkType: '',

      productInfo: this.propsObj.productInfo,

      rentalPeriodList: this.propsObj.productInfo.productOptions.rentalPeriod,
      colorList: this.propsObj.productInfo.productColors,
      option1List: this.propsObj.productInfo.productOptions.productOption1,
      option2List: this.propsObj.productInfo.productOptions.productOption2,
      option3List: this.propsObj.productInfo.productOptions.productOption3,
      instTypeList: this.propsObj.productInfo.productOptions.instType,
      checkTypeList: this.propsObj.productInfo.productOptions.checkType,

      // 선택 관련
      selectRentalPeriod: null,
      selectColor: null,
      selectOption1: null,
      selectOption2: null,
      selectOption3: null,
      prodCode: null,
      selectInstType: null,
      selectCheckType: null,

      popFlag: this.flag,
      btnText: '',
      amount: 0,

      msg: null,
      messagePop: null,
    };
  },
  mounted() {
    customjs.accoInit();
    customjs.plpOptInit();

    if (this.flag == 'rental') {
      this.btnText = '렌탈료';
      this.amount = this.productInfo.productDetail.rentalAmount;
    } else if (this.flag == 'payment') {
      this.btnText = '구매가';
      this.amount = this.productInfo.productDetail.saleAmount;
    }
  },
  beforeDestroy() {
    $('body').removeClass('popOn');
  },
  watch: {
    day() {
      this.rentalDay = false;
      this.dayText = this.day;
      document.getElementById('rentalDayText').classList.remove('placeholder');
    },
    color() {
      this.rentalColor = false;
      this.colorText = this.color;
      document.getElementById('rentalColorText').classList.remove('placeholder');
    },
    option1() {
      this.rentalOption1 = false;
      this.optionText1 = this.option1;
      document.getElementById('rentalOptionText1').classList.remove('placeholder');
    },
    option2() {
      this.rentalOption2 = false;
      this.optionText2 = this.option2;
      document.getElementById('rentalOptionText2').classList.remove('placeholder');
    },
    option3() {
      this.rentalOption3 = false;
      this.optionText3 = this.option3;
      document.getElementById('rentalOptionText3').classList.remove('placeholder');
    },
    instType() {
      this.rentalInstType = false;
      this.instTypeText = this.instType;
      document.getElementById('instTypeText').classList.remove('placeholder');
    },
    checkType() {
      this.rentalCheckType = false;
      this.checkTypeText = this.checkType;
      document.getElementById('checkTypeText').classList.remove('placeholder');
    },
  },
  methods: {
    selectOption: function() {
      let resultObj = [];

      if (!isEmpty(this.prodCode)) {
        let temp = new Object();
        temp.flag = 'prodCode';
        temp.value = this.prodCode;
        resultObj.push(temp);
      }

      if (!isEmpty(this.selectColor)) {
        let temp = new Object();
        temp.flag = 'color';
        temp.value = this.selectColor;
        resultObj.push(temp);
      }

      this.$emit('selectOption', resultObj);
    },
    getConvertPrice: function(value) {
      return convertPrice(value);
    },
    selectOptionItem: function(id, flag) {
      if (flag == 'color') {
        this.selectColor = id;
      } else if (flag == 'rentalPeriod') {
        this.selectRentalPeriod = id;
      } else if (flag == 'optionCode1') {
        this.selectOption1 = id;
      } else if (flag == 'optionCode2') {
        this.selectOption2 = id;
      } else if (flag == 'optionCode3') {
        this.selectOption3 = id;
      } else if (flag == 'instType') {
        this.selectInstType = id;
      } else if (flag == 'checkType') {
        this.selectCheckType = id;
      }

      let tempFlag = false;

      if (this.flag == 'rental' && this.rentalPeriodList.length > 0) {
        if (isEmpty(this.selectRentalPeriod)) {
          tempFlag = true;
        }
      }

      if (this.option1List.length > 0) {
        if (isEmpty(this.selectOption1)) {
          tempFlag = true;
        }
      }

      if (this.option2List.length > 0) {
        if (isEmpty(this.selectOption2)) {
          tempFlag = true;
        }
      }

      if (this.option3List.length > 0) {
        if (isEmpty(this.selectOption3)) {
          tempFlag = true;
        }
      }

      if (this.instTypeList.length > 0) {
        if (isEmpty(this.selectInstType)) {
          tempFlag = true;
        }
      }

      if (this.checkTypeList.length > 0) {
        if (isEmpty(this.selectCheckType)) {
          tempFlag = true;
        }
      }

      if (!tempFlag) {
        let optionCollect = this.productInfo.prodOptionCollect;
        if (this.option1List.length == 0) {
          this.selectOption1 = 'FM060001';
        }
        if (this.option2List.length == 0) {
          this.selectOption2 = 'FM060001';
        }
        if (this.option3List.length == 0) {
          this.selectOption3 = 'FM060001';
        }
        if (this.instTypeList.length == 0) {
          this.selectInstType = 'RNOR0001';
        }
        if (this.checkTypeList.length == 0) {
          this.selectCheckType = 'RREG0001';
        }
        for (let optionObj of optionCollect) {
          if (this.flag == 'payment') {
            if (
              this.selectOption1 == optionObj.optionCode1 &&
              this.selectOption2 == optionObj.optionCode2 &&
              this.selectOption3 == optionObj.optionCode3 &&
              this.selectInstType == optionObj.instType &&
              this.selectCheckType == optionObj.checkType
            ) {
              this.prodCode = optionObj.prodCode;
              this.amount = optionObj.saleAmount;
            }
          } else if (
            this.selectRentalPeriod == optionObj.rentalPeriod &&
            this.selectOption1 == optionObj.optionCode1 &&
            this.selectOption2 == optionObj.optionCode2 &&
            this.selectOption3 == optionObj.optionCode3 &&
            this.selectInstType == optionObj.instType &&
            this.selectCheckType == optionObj.checkType
          ) {
            this.prodCode = optionObj.prodCode;
            this.amount = optionObj.rentalAmount;
            if (this.amount < 0) {
              this.amount = 0;
            }
            break;
          }
        }
      } else {
        this.msg = ALLOPTION_SELECT;
        this.messagePop = true;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './css/popup.styl';

.popBody {
  max-height: 500px;
  padding-bottom: 150px;
}
</style>
